import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["generateButton", "linkDisplay", "urlInput", "copyButton"]
  static values = { workstationId: String }

  connect() {
    console.log("Enrollment controller connected")
  }

  async generateLink() {
    const workstationId = this.workstationIdValue
    
    try {
      this.generateButtonTarget.disabled = true
      this.generateButtonTarget.textContent = "Génération en cours..."
      
      const response = await fetch(`/admin/workstations/${workstationId}/generate_enrollment_token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      if (!response.ok) {
        const errorText = await response.text()
        console.error('Erreur HTTP:', response.status, errorText)
        throw new Error(`Erreur HTTP ${response.status}: ${response.statusText}`)
      }
      
      const contentType = response.headers.get('content-type')
      if (!contentType || !contentType.includes('application/json')) {
        const responseText = await response.text()
        console.error('Réponse non-JSON reçue:', responseText)
        throw new Error('Le serveur n\'a pas retourné de JSON valide')
      }
      
      const data = await response.json()
      
      this.urlInputTarget.value = data.enrollment_url
      this.generateButtonTarget.classList.add('hidden')
      this.linkDisplayTarget.classList.remove('hidden')
      
    } catch (error) {
      console.error('Erreur:', error)
      alert(`Une erreur est survenue lors de la génération du lien d'enrôlement: ${error.message}`)
      this.generateButtonTarget.disabled = false
      this.generateButtonTarget.textContent = "Générer un lien d'enrôlement"
    }
  }

  async copyLink() {
    try {
      await navigator.clipboard.writeText(this.urlInputTarget.value)
      
      // Feedback visuel
      const originalHTML = this.copyButtonTarget.innerHTML
      this.copyButtonTarget.innerHTML = '<svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>'
      this.copyButtonTarget.classList.add('text-green-600')
      
      setTimeout(() => {
        this.copyButtonTarget.innerHTML = originalHTML
        this.copyButtonTarget.classList.remove('text-green-600')
      }, 2000)
      
    } catch (err) {
      // Fallback pour les navigateurs plus anciens
      this.urlInputTarget.select()
      document.execCommand('copy')
      
      // Même feedback visuel
      const originalHTML = this.copyButtonTarget.innerHTML
      this.copyButtonTarget.innerHTML = '<svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>'
      this.copyButtonTarget.classList.add('text-green-600')
      
      setTimeout(() => {
        this.copyButtonTarget.innerHTML = originalHTML
        this.copyButtonTarget.classList.remove('text-green-600')
      }, 2000)
    }
  }
}
